// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateFax, ValidatePhone } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

const phoneRegex = /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){8,}$/;

const isEmpty = (value: string) => value.trim().length <= 0;
const isValidPhoneNumber = (value: string) => phoneRegex.test(value);

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const StoreValidatePhone = createChainHandler("StoreValidatePhone", chain, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { phone } = props.parameter.address;
    if (addressFieldDisplayCollection.phone?.isVisible && validationRules.phone?.isRequired && isEmpty(phone)) {
        props.addressErrors.phone = getRequiredErrorMessage(addressFieldDisplayCollection.phone);
    } else if (!isEmpty(phone) && !isValidPhoneNumber(phone)) {
        props.addressErrors.phone = siteMessage("AddressInfo_Phone_Validation");
    }
});

export const StoreValidateFax = createChainHandler("StoreValidatePhone", chain, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { fax } = props.parameter.address;
    if (addressFieldDisplayCollection.fax?.isVisible && validationRules.fax?.isRequired && isEmpty(fax)) {
        props.addressErrors.fax = getRequiredErrorMessage(addressFieldDisplayCollection.fax);
    } else if (!isEmpty(fax) && !isValidPhoneNumber(fax)) {
        props.addressErrors.fax = siteMessage("AddressInfo_Phone_Validation");
    }
});

replaceInChain(chain, ValidatePhone, StoreValidatePhone);
replaceInChain(chain, ValidateFax, StoreValidateFax);
